import axios from "axios"
import Cookies from 'universal-cookie'

const cookies = new Cookies();

let refreshTimeout = null;


export const getAccessToken = (code) => dispatch => {

    const urlToken = window.urlToken;
    const paramsToken = window.tokenParams.replace('{$code}', code);

    axios.post(urlToken, paramsToken, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then( response => {
        dispatch({
            type: "POST_TOKEN_SUCCESS",
            results: response.data,
            status: response.status
        });

        axios.get(window.urlInfoMe, {
            headers: {
                'Authorization': "Bearer " + response.data.access_token
            }
        })
            .then( response => {
                dispatch({
                    type: "GET_INFO_ME_SUCCESS",
                    results: response.data,
                    status: response.status
                });

            }).catch(function (error) {
            dispatch({
                type: "GET_INFO_ME_ERROR",
                status:false
            });

        });

        axios.get(window.urlMenuAdocs).then( response => {

            dispatch({
                type: "GET_MENU_ASCIIDOC_SUCCESS",
                results:response.data._links,
                status:response.status
            });
        }).catch(function (error) {
            dispatch({
                type: "GET_MENU_ASCIIDOC_ERROR",
                status:false
            });
        });

        setTimeout(() => {
            refreshToken();
        }, (response.data.refresh_expires_in*60-10000));

    }).catch(function (error) {
        dispatch({
            type: "POST_TOKEN_ERROR",
            status:false
        });
    });
};

export const logOut = () => {


    cookies.set('access_token', null);
    cookies.set('refresh_token', null);
    cookies.set('menu_adocs', null);
    cookies.set('user', null);
    cookies.set('menus', null);
    cookies.set('isConnected', false);

    clearTimeout(refreshTimeout);

    window.location.href = window.urlLogout;
};

export function refreshToken() {
    const refreshTokenCookies = cookies.get('refresh_token');
    if(refreshTokenCookies && refreshTokenCookies !== "null") {
        const urlToken = window.urlToken;
        const paramsRefreshToken = window.tokenRefreshParams.replace("{$refreshToken}", refreshTokenCookies);
        axios.post(urlToken,paramsRefreshToken,{
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then( response => {
            cookies.set('refresh_token', response.data.refresh_token, {maxAge: response.data.refresh_expires_in});
            cookies.set('access_token', response.data.access_token, {maxAge: response.data.expires_in});
            refreshTimeout = setTimeout(() => {
                refreshToken();
            }, ((response.data.refresh_expires_in * 1000) - 5000));
        }).catch(function (error) {
            logOut();
        });
    }
}

//Interceptor for set access_token before request.
// or refresh token if err 401

axios.interceptors.request.use(function(config) {
    const token = cookies.get('access_token');

    if (token && token !== null && token !== "null") {
        config.headers.Authorization = `Bearer ${token}`;
    } 

    return config;
}, function(error) {

    return Promise.reject(error);
});

axios.interceptors.response.use(function(response) {
    return response;
}, function(error) {
    const refreshToken = cookies.get('refresh_token');

    const urlToken = window.urlToken;

    let originalRequest = error.config;
    if (error.response && (error.response.status === 401 || error.response.status === 403))  {
        if (!originalRequest._retry) {
            originalRequest._retry = true;
            const paramsRefreshToken = window.tokenRefreshParams.replace("{$refreshToken}", refreshToken);

            return axios.post(urlToken,paramsRefreshToken,{
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then( response => {
                cookies.set('refresh_token', response.data.refresh_token, {maxAge: response.data.refresh_expires_in});
                cookies.set('access_token', response.data.access_token, {maxAge: response.data.expires_in});
                originalRequest.headers.Authorization = `Bearer ${response.data.access_token}`;
                return axios(originalRequest);
            }).catch(function (error) {
                logOut();
            });
        }

    }
    return Promise.reject(error);
})
